export const environment = {
  production: true,
  wsServerUrl: `wss://apiws.melcoapplyme.com/ws`,
  apiServerUrl: 'https://api.melcoapplyme.com/v1/applyme',
  disableCompanies: false,
  disableProjectList: false,
  disableSelectionList: false,
  env: 'prod',
  keycloakConfig: {
    url: 'https://auth.melcoapplyme.com/auth/',
    realm: 'applyme',
    clientId: 'applyme-fe',
  },
  sentry: {
    enabled: false,
    dsn: '',
    tracePropagationTargets: [],
  },
};
